



































import { Component, Prop, Vue } from 'vue-property-decorator';
import CategoryCard from '../../frontend/components/CategoryCard.vue';
import PizzaLoader from '../../frontend/components/PizzaLoader.vue';
import OrderModal from '../../frontend/components/OrderModal.vue';
import ShoppingCart from '../../frontend/components/ShoppingCart.vue';
import OrderItem from "../../logic/model/OrderItem";
import { cookies } from 'brownies'
import ApiConnector from "../../logic/connector/ApiConnector";
import OrderItemMarshaller from "../../logic/model/OrderItemMarshaller";
import Category from "../../logic/model/Category";


@Component({
    components: {
        CategoryCard,
        PizzaLoader,
        OrderModal,
        ShoppingCart
    }
})
export default class Articles extends Vue {

    private dialog:Boolean = false;
    private order:any = null;
    private selectedCategories:Array<Category> = [];


    createOrderModal(order:Object) {
        this.order = order;
        this.dialog = true;
    }

    get selection() {
        if (this.selectedCategories.length > 0) {
            return this.selectedCategories
        }
        return this.categories;
    }

    get visibleCategories() {
        let items:any = [];
        this.categories.forEach( (category:Category) => {
            items.push({text: category.$name, value: category})
        });
        return items;
    }

    get categories() {
        return this.$store.state.categories
    }

    get articlesLoading() {
        return this.$store.state.isArticlesLoading;
    }

    get ordersLoading() {
        return this.$store.state.isOrdersLoading;
    }

    save(orderItem:OrderItem) {
        this.dialog = false;
        console.log(new OrderItemMarshaller(orderItem).toJSON())
        new ApiConnector().post(
            '/api/orderPizza',
            new OrderItemMarshaller(orderItem).toJSON()
        ).then(response => {
            console.log(response)
        })
        this.order = null
    }

    removeOrder(orderItem:OrderItem) {
        new ApiConnector().delete('/api/order/' + orderItem.$id)
    }



    
}
